<template>
  <yartu-notify></yartu-notify>
  <yartu-modal></yartu-modal>
  <router-view></router-view>
</template>
<script setup>
import { initUserDetail } from '@/auth';

initUserDetail();

</script>
<style>
html {
  scroll-behavior: smooth;
}
</style>
